/* src/app/ships/ship-roster/ship-roster.component.css */
.align-vertical {
  padding-top: 7px;
}
#userProfilePage:hover {
  color: rgba(23, 79, 141, 0.85);
  text-decoration: underline;
}
.missing-info-msg {
  padding: 1.5rem 1rem 0 1rem;
  font-size: 1.15rem;
}
.missing-info-msg i {
  color: red;
}
td.transfer button {
  margin-right: 3rem;
}
td.transfer i.fa {
  font-size: 1.1rem;
}
td.transfer i.fa-times {
  color: red;
}
td.transfer i.fa-check {
  color: green;
}
/*# sourceMappingURL=ship-roster.component.css.map */
